import '@emailforge/tokens/tokens.css';
import './styles/global.scss';

import { DialogProvider } from '@emailforge/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import { SessionBootstrap } from './features/auth/SessionBootstrap';
import { initMonitoring } from './lib/monitoring';
import { router } from './router';
import { store } from './store';

// Fire-and-forget: initMonitoring is a no-op without env vars set, and
// providers attach asynchronously without blocking the first paint.
void initMonitoring();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <SessionBootstrap>
          <DialogProvider>
            <RouterProvider router={router} />
          </DialogProvider>
        </SessionBootstrap>
      </Provider>
    </ErrorBoundary>
  </StrictMode>,
);
